import { BookOpenText, ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { scrollToSection } from "@/lib/scroll";

const IMG =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_covenant-coaching/artifacts/c2tsguxp_marriage%20photo.png";

const learnings = [
  "Learn about the pitfalls",
  "Things to focus on",
  "Things to avoid",
  "Most important — learning how to communicate",
];

export const PreMarital = () => (
  <section id="premarital" className="py-24 lg:py-32 bg-[#2C2A28] relative overflow-hidden" data-testid="premarital-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-12 gap-10 items-center">
      <div className="col-span-12 lg:col-span-7">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.25em] text-[#C4B299] mb-4">Pre-marital coaching</p>
          <h2 className="font-serif-display text-4xl sm:text-5xl font-medium tracking-tight text-[#FAF9F6] max-w-2xl">
            The conversation almost no one has —{" "}
            <em className="italic text-[#C4B299]">before the wedding.</em>
          </h2>
        </Reveal>

        <Reveal delay={0.15}>
          <p className="font-serif-display italic text-2xl md:text-3xl leading-snug text-[#FAF9F6] mt-10 max-w-xl" data-testid="premarital-question">
            "Wouldn't you want the tools necessary before entering into a lifelong covenant with
            someone else?"
          </p>
        </Reveal>

        <Reveal delay={0.25}>
          <ul className="mt-10 space-y-4">
            {learnings.map((l) => (
              <li key={l} className="flex items-center gap-4 text-[#C4B299]/90 font-light">
                <BookOpenText size={16} strokeWidth={1.5} className="text-[#8A5A44] shrink-0" />
                {l}
              </li>
            ))}
          </ul>
          <button
            onClick={() => scrollToSection("book")}
            className="group mt-10 rounded-full bg-[#8A5A44] hover:bg-[#734A38] text-[#FAF9F6] px-8 py-4 text-sm flex items-center gap-2 transition-colors duration-300"
            data-testid="premarital-cta"
          >
            Start before "I do"
            <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
          </button>
        </Reveal>
      </div>

      <Reveal delay={0.2} className="col-span-12 lg:col-span-5">
        <div className="rounded-3xl overflow-hidden">
          <img
            src={IMG}
            alt="Wedding rings, a journal reading love is patient love is kind, and a winding road at sunset"
            className="w-full h-[380px] lg:h-[520px] object-cover"
            data-testid="premarital-image"
          />
        </div>
      </Reveal>
    </div>
  </section>
);
